import classnames from 'classnames';
import { ThemeOptions } from '../publicSession/types';
export function getGlobalClassnamesForContext(_a) {
    var isMobile = _a.isMobile, theme = _a.theme, isSisu = _a.isSisu;
    return classnames(isMobile && 'mobile', !isSisu && "theme-" + (theme || ThemeOptions.DARK).toString(), isSisu && 'sisu');
}
export function getForcedGlobalClassnamesForContext(_a) {
    var theme = _a.theme;
    return "theme-" + theme + " forced-theme-" + theme;
}
//# sourceMappingURL=helpers.js.map